import React, { useEffect } from 'react';
import { PlayProvider, CanToggleElement, CanMoveElement } from "@playhtml/react";

import Content from './Content';
import Test from './Test';
import styles from './App.module.css';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([{
  path: "/",
  element: <Content />,
}]);



function calcValues() {
  const centerContent = document.getElementById('center-content');
  const centerFold = document.getElementById('center-fold');

  const overflowHeight = centerContent.clientHeight - centerFold.clientHeight;

  document.body.style.height = overflowHeight + window.innerHeight + 'px';
  const foldsContent = Array.from(
    document.querySelectorAll('[data-fold-content="true"]'),
  );
  const tick = () => {
    const scroll = -(
      document.documentElement.scrollTop || document.body.scrollTop
    );
    foldsContent.forEach(content => {
      content.style.transform = `translateY(${scroll}px)`;
    });
    requestAnimationFrame(tick);
  };

  tick();
}

function BunnyField() {
  const template = useRef < HTMLDivElement > (null);
  const field = useRef < HTMLDivElement > (null);

  return (
    <div>
      <div id="bunny-template" ref={template}>🐰</div>
      <div id="bunny-field" ref={field} />
      <CanDuplicateElement elementToDuplicate={template} canDuplicateTo={field}>
        <button>clone a bunny</button>
      </CanDuplicateElement>
    </div>
  );
}

function App() {
  useEffect(() => {
    window.addEventListener('resize', calcValues);
    calcValues();
  }, []);


  return (
    <section >
      <PlayProvider id='sectionroot'
        initOptions={{
          cursors: {
            enabled: true,

            shouldRenderCursor: (presence) => {
              // Only render cursors from the same page
              return presence.page === window.location.pathname;
            }
          }
        }}
      >


        <div className={styles.all}>

          <div className={styles.wrapper3d}>
            <div className={`${styles.fold} ${styles.foldTop}`}>
              <div className={styles.foldAlign} id="top-fold">
                <div data-fold-content="true">
                  <Content />
                  {/* <Router>
                <Routes>
                  <Route path="/" element={<Content />} />
                  <Route path="/home" element={<Content />} />

                </Routes>
              </Router> */}
                </div>
              </div>
            </div>
            <div className={styles.fold} id="center-fold">
              <div className={styles.foldAlign}>
                <div data-fold-content="true" id="center-content">
                  <Content />
                  {/* <Router>
                <Routes>
                  <Route path="/" element={<Content />} />
                  <Route path="/home" element={<Content />} />

                </Routes>
              </Router> */}
                </div>
              </div>
            </div>
            <div className={`${styles.fold} ${styles.foldBottom}`}>
              <div className={styles.foldAlign} id="bottom-fold">
                <div data-fold-content="true">
                  <Content />

                  {/* <Router>
                <Routes>
                  <Route path="/" element={<Content />} />
                  <Route path="/home" element={<Content />} />

                </Routes>
              </Router> */}

                </div>
              </div>
            </div>
          </div>
        </div>

        <div >
          <CanMoveElement>
            <div> </div>
          </CanMoveElement>

          <CanMoveElement>
            <div>🏳️‍⚧️  </div>
          </CanMoveElement>

          <CanMoveElement bounds='sectionroot'>
            <div>🫃 </div>
          </CanMoveElement>





        </div>
      </PlayProvider>
    </section>
  );
}

export default App;
